import React, { useState } from "react";
import Button from "react-bootstrap/Button";

const PleaseDownloadComponent = () => {
  return (
    <div style={{maxWidth:'330px'}}>
			<div style={{textAlign:'center'}} title="Welcome">
				<p>Welcome to SoundMeshWeb!</p>
				<p>In order to use it, please:</p>
				<p>1) Install this hot-fixed version of RTcmix:</p>
				<Button as='a' target='_blank' download href='https://drive.google.com/file/d/1EWphHmJHznmd3QP3gTM01rePi29wp6dD/view?usp=sharing'>
					Download RTcmix
				</Button>
				<p>2) Download this server app: (please keep the executable file and the public folder in the same folder)</p>
				<Button as='a' target='_blank' download href='https://drive.google.com/drive/folders/1hFHOQ2PAxeXKyNMvZkIULR7rbPAyk5zu?usp=sharing'>
					Download the app
				</Button>
				<p>Note: For online streaming, you may use this online version. Just create a new online streaming component.</p>
			</div>
		</div>
  );
};

export default PleaseDownloadComponent;
